const ACCESS_TOKEN_KEY = "ep.accessToken"
const REFRESH_TOKEN_KEY = "ep.refreshToken"
const ACCESS_EXPIRES_AT_KEY = "ep.accessExpiresAt"

export interface StoredTokens {
  accessToken: string
  refreshToken: string
  accessExpiresAt: number
}

export function readTokens(): StoredTokens | null {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY)
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY)
  const expiresAtRaw = localStorage.getItem(ACCESS_EXPIRES_AT_KEY)

  if (!accessToken || !refreshToken || !expiresAtRaw) {
    return null
  }

  const accessExpiresAt = Number(expiresAtRaw)
  if (Number.isNaN(accessExpiresAt)) {
    return null
  }

  return { accessToken, refreshToken, accessExpiresAt }
}

export function writeTokens(tokens: {
  accessToken: string
  refreshToken: string
  expiresIn: number
}) {
  const accessExpiresAt = Date.now() + tokens.expiresIn * 1000
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken)
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken)
  localStorage.setItem(ACCESS_EXPIRES_AT_KEY, String(accessExpiresAt))
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(ACCESS_EXPIRES_AT_KEY)
}
